export default __webpack_public_path__ + "static/media/logo_vertical.2c3831b8.png";